import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, PreloadAllModules, RouterModule } from '@angular/router';
import { MarkdownModule } from 'ngx-markdown';
import { FuseModule } from '@fuse';
import { FuseConfigModule } from '@fuse/services/config';
import { FuseMockApiModule } from '@fuse/lib/mock-api';
import { CoreModule } from 'app/system/core.module';
import { appConfig } from 'app/system/app.config';
import { mockApiServices } from 'app/z/mock-api';
import { LayoutModule } from 'app/layout/layout.module';
import { AppComponent } from 'app/app.component';
import { PlatformGlobalMessageComponent } from 'app/shared/platform/platform-global-message.component';
import { LifecycleBannerComponent } from 'app/shared/lifecycle/lifecycle-banner.component';
import { AppMaintenancePageComponent } from 'app/shared/maintenance/app-maintenance-page.component';
import { appRoutes } from 'app/app.routing';

const routerConfig: ExtraOptions = {
    scrollPositionRestoration: 'enabled',
    preloadingStrategy: PreloadAllModules
};

const markdownModule = MarkdownModule.forRoot({});

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        LifecycleBannerComponent,
        PlatformGlobalMessageComponent,
        AppMaintenancePageComponent,
        BrowserModule,
        RouterModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, routerConfig),

        // Fuse & Fuse Mock API
        FuseModule,
        FuseConfigModule.forRoot(appConfig),
        FuseMockApiModule.forRoot(mockApiServices),
        markdownModule,

        // Core
        CoreModule,

        // Layout
        LayoutModule,

        // 3rd party modules
        MarkdownModule.forRoot({})
    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule { }
